var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title mb-5"},[_c('div',{staticClass:"section-title text-center"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"en-title mt-n3 mt-md-n9 text-center"},[_vm._v(_vm._s(_vm.enTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }